import styled from "styled-components";

export const CardContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  overflow: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  height: 100%;
  /* max-width: 375px; */
  box-sizing: border-box;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: all 0.2s ease;
  position: relative;
  x &:hover {
    box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1),
      0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  }

  /* Bootstrap breakpoints */
  @media (max-width: 576px) {
    max-width: 100%;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  height: 116px;
  border-radius: 4px 4px 0 0;
  object-fit: cover;
  background: linear-gradient(0deg, #e1e2ea 0%, #e1e2ea 100%);

  @media (max-width: 576px) {
    height: 100px;
  }
`;

export const RecommendedBadge = styled.div`
  position: absolute;
  top: 14px;
  left: 20px;
  border-radius: 9999px;
  background: radial-gradient(
    131.48% 106.87% at 53.3% 40.91%,
    rgba(35, 35, 35, 0.5) 0%,
    rgba(118, 118, 118, 0.5) 100%
  );
  box-shadow: 0 2px 20px 0 rgba(103, 103, 103, 0.15);
  padding: 4px 12px;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  background: linear-gradient(51deg, #fff -2.46%, #f4f4f4 86.45%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 576px) {
    font-size: 11px;
    padding: 3px 10px;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px 16px 16px;
  flex: 1;
`;

export const Subtitle = styled.span`
  color: #717680;
  font-family: "Aeonik", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 1.12px;
  /*  */
  @media (max-width: 576px) {
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.98px;
  }
`;

export const Title = styled.h3`
  color: #181d27;
  font-family: "Aeonik", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  margin: 0;

  @media (max-width: 576px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const TagRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;

  @media (min-width: 576px) {
    gap: 8px;
  }
`;

export const TagButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  background: #ffffff;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #414651;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  ${({ type }) =>
    type === "type" &&
    `
      background: linear-gradient(135deg, #E8D07A 0%, #5312D6 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      svg {
        fill: url(#gradient);
      }
    `}

  &:hover {
    border-color: #717680;
  }

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }

  @media (max-width: 576px) {
    padding: 2px 6px;
    font-size: 11px;
    line-height: 16px;
    gap: 2px;

    svg {
      width: 10px;
      height: 10px;
    }
  }
`;
